import styled from 'styled-components';

export const Subtitle = styled.div`
    text-align: center;
    color: ${ ({ theme: { textColor } }) => textColor };
    margin-bottom: 20px;
`;

export const Version = styled.div`
    color: gray;
    font-size: 10px;
    margin-top: 10px;
    opacity: 0.8;
    text-align: center;
`;
